import React, { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import noop from 'utils/noop';
import { MenuItemText, MenuItemContentWrapper } from './Styled';

type BasicMenuItemProps = {
  /** DOM nodes to display inside the item */
  children?: React.ReactNode;
  /** Component that will be displayed in the menu item if label or children is not provided. */
  content?: React.ReactNode;
  /**  Identifier of the menu item */
  id: string;
  /** If true, the menu item checkbox will be selected */
  isSelected?: boolean;
  /** If true, the menu item will be disabled */
  isDisabled?: boolean;
  /** Text that will be displayed in the menu item if content or children is not provided.
  Required if the menu has search filter, as the string representation of the content displayed */
  label?: string;
  /** Callback function to call when there is a selection change */
  onSelectionChange?: (id: string) => void;
};

export const BasicMenuItem = ({
  children,
  content,
  id,
  isSelected = false,
  isDisabled = false,
  label,
  onSelectionChange = noop,
}: BasicMenuItemProps) => {
  const [isActive, setIsActive] = useState(isSelected);
  const wrapperRef = useRef(null);

  useClickAway(wrapperRef, () => {
    setIsActive(false);
  });

  return (
    <MenuItemContentWrapper
      as="li"
      data-test={`basic-menu-item-${id}`}
      isActive={isActive}
      onClick={() => {
        if (!isDisabled) {
          onSelectionChange(id);
          setIsActive(true);
        }
      }}
      ref={wrapperRef}
      isDisabled={isDisabled}
    >
      {children || <MenuItemText isActive={isActive}>{content || label}</MenuItemText>}
    </MenuItemContentWrapper>
  );
};
